import toast from 'react-hot-toast';

const Snackbar = ({ message, type }: { message: string, type: string }) => {

    if (message != 'Primeiro acesso do usuário.' &&
        message != 'Nenhum usuário encontrado com o e-mail informado.' &&
        !message.startsWith('O número de telefone deve ter')) {

        if (type === 'success') {
            toast.success(message, { duration: 10000 })
        }

        if (type === 'error') {
            toast.error(message, { duration: 10000 })
        }
    }

}

export default Snackbar